<template>
  <div class="grid-content">
    <div
      class="loading"
      v-loading="loading"
    >
      <el-form
        ref="globalPriceSetting"
        :model="globalPriceSetting"
        :rules="rules"
        label-width="200px"
        label-position="left"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item
              label="手续费占比"
              prop="ValueView"
            >
              <el-input
                :disabled="optionModel.isReadonly"
                placeholder="请输入价格"
                v-model="globalPriceSetting.ValueView"
                class="input-width"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <hr>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-row
      v-if="!optionModel.isReadonly"
      class="cs-filter-row"
    >
      <el-col
        :span="4"
        class="footer-left"
      >
        <el-button
          size="medium"
          :disabled="submitBtnDisable"
          :type="submitBtnClass"
          @click="saveChanges"
        >保存更新</el-button>
      </el-col>
      <el-col
        :span="16"
        class="footer-right"
      >
        <el-alert
          :closable="false"
          v-show="showError"
          v-bind:title="errorMessage"
          type="error"
          show-icon
        ></el-alert>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.el-col {
  span {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    overflow: visible;
    white-space: nowrap;
  }

  .el-input {
    text-align-last: center;
  }
}
</style>

<script>
import {
  getGlobalPriceSettingByType,
  saveGlobalPriceSetting
} from "../../service/globalPriceSetting.service";

export default {
  props: {
    isActive: Boolean,
    options: {
      isReadonly: Boolean
    }
  },
  data() {
    let validateValue = (rule, value, callback) => {
      let message = "";
      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);
      if (!!value && !isValid) {
        message = "请输入正确的费率";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      isLoadedData: false,
      loading: false,
      optionModel: {
        isReadonly: false
      },
      globalPriceSetting: {},
      submitBtnClass: "info",
      submitBtnDisable: true,
      showError: false,
      errorMessage: "",
      rules: {
        ValueView: [
          {
            required: true,
            message: "费率不能为空",
            trigger: "blur"
          },
          {
            validator: validateValue,
            trigger: "blur"
          }
        ]
      }
    };
  },
  components: {},
  computed: {},
  created() {
    this.loadOptionModelFromProps();
    this.loadGlobalPriceSetting();
  },
  updated() {
    this.checkAllInputs();
  },
  methods: {
    loadOptionModelFromProps(options = this.options) {
      if (!!options) {
        this.optionModel.isReadonly = options.isReadonly;
      } else {
        this.optionModel.isReadonly = false;
      }
    },
    checkAllInputs() {
      let isValid = true;

      let $refGPS = this.$refs["globalPriceSetting"];
      if (!!$refGPS) {
        $refGPS.validate(valid => {
          if (!valid) {
            isValid = false;
            return;
          }
        });
      }

      if (isValid) {
        this.submitBtnClass = "primary";
        this.submitBtnDisable = false;
      } else {
        this.submitBtnClass = "info";
        this.submitBtnDisable = true;
      }

      return isValid;
    },
    loadGlobalPriceSetting() {
      if (!this.isActive){
        return;
      }

      let self = this;

      this.loading = true;
      getGlobalPriceSettingByType(5).then(result => {
        if (!!result && result.success) {
          self.globalPriceSetting = self.__initGPSViewProperty(result.data);
          self.loading = false;
          self.isLoadedData = true;
        }
      });
    },
    saveChanges() {
      let self = this;

      let isValid = this.checkAllInputs();
      if (!isValid) {
        return;
      }

      let cacheSubmitBtnDisable = this.submitBtnDisable;
      this.submitBtnDisable = true;
      let data = this.__destoryGPSViewProperty(this.globalPriceSetting);
      saveGlobalPriceSetting(data).then(result => {
        if (!result) {
          return;
        }

        if (result.success) {
          self.globalPriceSetting.Id = result.data;
          self.errorMessage = "";
        } else {
          self.errorMessage = result.message;
        }
        self.showError = !result.success;
        self.$message(`保存更新${!self.showError ? "成功" : "失败"}`);
        self.submitBtnDisable = cacheSubmitBtnDisable;
      });
    },
    __initGPSViewProperty(obj) {
      let retObj = $.extend(true, {}, obj);

      if (retObj.ValueView == undefined) {
        $.extend(retObj, {
          ValueView: retObj.Value * 100
        });
        delete retObj.Value;
      }

      return retObj;
    },
    __destoryGPSViewProperty(obj) {
      let retObj = $.extend(true, {}, obj);

      if (retObj.Value == undefined) {
        $.extend(retObj, {
          Value: retObj.ValueView / 100
        });
        delete retObj.ValueView;
      }

      return retObj;
    }
  },
  watch: {
    isActive: function () {
      if (this.isActive && !this.isLoadedData) {
          this.loadGlobalPriceSetting();
      }
    },
    options: function(newVal) {
      this.loadOptionModelFromProps(newVal);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/paymentCommissionRate.vue